import styled from 'styled-components';
import colors from 'basic-ui-lib/constants/colors';

const Container = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  text-align: start;
`;

const SwatchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const SwatchBox = styled.div`
  width: 5rem;
  height: 3rem;
  position: relative;
`;

const ColorOverlay = styled.div<{ background: string }>`
  position: relative;
  width: 100%;
  height: 100%;
  background: ${(props) => props.background};
`;

const Label = styled.div`
  font-size: 0.75rem;
  color: #64748b;
`;

const Code = styled.div`
  margin-top: 0.25rem;
  max-width: 150px;
  word-break: break-all;
  font-size: 12px;
  color: black;
`;

const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const GroupTitle = styled.div`
  font-weight: 500;
`;

const SwatchGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

const SectionTitle = styled.div`
  font-size: 1.125rem;
  font-weight: 500;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

interface ColorSwatchProps {
  value: string;
  name: string;
  code?: string;
}

const ColorSwatch = ({ value, name, code }: ColorSwatchProps) => (
  <SwatchContainer>
    <SwatchBox>
      <ColorOverlay background={value} />
    </SwatchBox>
    <Label>
      {`${code} - ${value}`}
      <Code>{name}</Code>
    </Label>
  </SwatchContainer>
);

interface ColorGroupProps {
  title: string;
  groupTitle?: string;
  colors: Record<string | number, string>;
}
const toCamelCase = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => (index === 0 ? match.toLowerCase() : match.toUpperCase()))
    .replace(/\s+/g, '');
};
const ColorGroup = ({ title, colors, groupTitle }: ColorGroupProps) => (
  <GroupContainer>
    <GroupTitle>{title}</GroupTitle>
    <SwatchGrid>
      {Object.entries(colors).map(([key, value]) => (
        <ColorSwatch
          key={`${title}-${key}`}
          value={value}
          code={key}
          name={`colors${groupTitle ? `.${toCamelCase(groupTitle)}` : ''}.${toCamelCase(title)}.${key}`}
        />
      ))}
    </SwatchGrid>
  </GroupContainer>
);

export const ColorsStoryboard = () => (
  <Container>
    <ColorGroup title='Primary' colors={colors.primary} />
    <ColorGroup title='Secondary' colors={colors.secondary} />
    <ColorGroup title='Gradient' colors={colors.gradient} />
    <ColorGroup title='Orange' colors={colors.orange} />
    <ColorGroup title='Yellow' colors={colors.yellow} />
    <ColorGroup title='Purple' colors={colors.purple} />
    <ColorGroup title='Other' colors={colors.other} />

    <Section>
      <SectionTitle>Neutral</SectionTitle>
      <ColorGroup groupTitle='Neutral' title='Text' colors={colors.neutral.text} />
      <ColorGroup groupTitle='Neutral' title='Icon' colors={colors.neutral.icon} />
      <ColorGroup groupTitle='Neutral' title='Border' colors={colors.neutral.border} />
      <ColorGroup groupTitle='Neutral' title='Bg' colors={colors.neutral.bg} />
    </Section>

    <Section>
      <SectionTitle>Opacity</SectionTitle>
      <ColorGroup groupTitle='Opacity' title='White' colors={colors.opacity.white} />
      <ColorGroup groupTitle='Opacity' title='Black' colors={colors.opacity.black} />
      <ColorGroup groupTitle='Opacity' title='Blue Gray' colors={colors.opacity.blueGray} />
    </Section>
  </Container>
);
